import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const DelegationRoute = lazyWithRetries(() => import('./'))
const CreateDelegatesRoute = lazyWithRetries(() => import('./configureDelegates/CreateDelegates'))
const ConfigureDelegatesRoute = lazyWithRetries(() => import('./configureDelegates/EditDelegation'))
const DelegateAwardRoute = lazyWithRetries(() => import('./delegateAward'))
const DelegateAwardBulkSendRoute = lazyWithRetries(() => import('./delegateAward/bulkSend'))

const delegateBulkSendElement = (
  <StandardPageLayout
    elementId="delegateBulkSendRoute"
    title={<T _str="Bulk send award" />}
    maxWidth={1080}>
    <Suspense fallback={<RouteLoading />}>
      <DelegateAwardBulkSendRoute />
    </Suspense>
  </StandardPageLayout>
)

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.delegation(':tab?'),
    element: (
      <StandardPageLayout
        elementId="delegationRoute"
        title={<T _str="Delegation" />}
        maxWidth={1440}>
        <Suspense fallback={<RouteLoading />}>
          <DelegationRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.createDelegates(),
    element: (
      <StandardPageLayout
        elementId="createDelegatesRoute"
        title={<T _str="Assign delegates" />}
        maxWidth={900}>
        <Suspense fallback={<RouteLoading />}>
          <CreateDelegatesRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.editDelegate(':id?'),
    element: (
      <StandardPageLayout
        elementId="configureDelegatesRoute"
        maxWidth={900}
        title={<T _str="Edit delegation" />}>
        <Suspense fallback={<RouteLoading />}>
          <ConfigureDelegatesRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.delegateAwards(),
    element: (
      <StandardPageLayout
        elementId="delegateAwardRoute"
        title={<T _str="Send an award" />}
        maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <DelegateAwardRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.delegateBulkSendAward(),
    element: delegateBulkSendElement,
  },
  {
    path: AppPaths.tenant.admin.delegateBulkSendAward(':batchId'),
    element: delegateBulkSendElement,
  },
]

export default routes
